module.exports = __webpack_public_path__ + "img/logo-USDT-TRC-tmp.bc4bdb62.svg";